import { Turbo } from "@hotwired/turbo-rails"

function createConfirmDialog(message) {
  return new Promise((resolve) => {
    const overlay = document.createElement("div")
    overlay.className = "modal-overlay"

    const title = document.querySelector('meta[name="confirm-title"]')?.content
    const cancelLabel = document.querySelector('meta[name="confirm-cancel"]')?.content
    const confirmLabel = document.querySelector('meta[name="confirm-confirm"]')?.content

    overlay.innerHTML = `
      <div class="modal">
        <div class="modal-title">${title}</div>
        <p class="modal-body">${message}</p>
        <div class="modal-actions">
          <button class="btn btn-secondary" data-role="cancel">${cancelLabel}</button>
          <button class="btn btn-danger" data-role="confirm">${confirmLabel}</button>
        </div>
      </div>
    `

    const cleanup = () => {
      overlay.classList.remove("active")
      overlay.addEventListener("transitionend", () => overlay.remove(), { once: true })
      setTimeout(() => overlay.remove(), 300)
    }

    const cancel = () => { cleanup(); resolve(false) }
    const confirm = () => { cleanup(); resolve(true) }

    overlay.querySelector('[data-role="cancel"]').addEventListener("click", cancel)
    overlay.querySelector('[data-role="confirm"]').addEventListener("click", confirm)
    overlay.addEventListener("click", (e) => { if (e.target === overlay) cancel() })

    const keyHandler = (e) => {
      if (e.key === "Escape") {
        cancel()
        document.removeEventListener("keydown", keyHandler)
      }
    }
    document.addEventListener("keydown", keyHandler)

    document.body.appendChild(overlay)
    requestAnimationFrame(() => {
      overlay.classList.add("active")
      overlay.querySelector('[data-role="cancel"]').focus()
    })
  })
}

Turbo.config.forms.confirm = createConfirmDialog
